module.exports = __webpack_public_path__ + "img/photo-3-1.7b6b7b77.jpg";